export default __webpack_public_path__ + "static/media/Wallet.1ab389bd.svg";